import { useCallback, useState } from 'react';

const NOTIFICATION_SOUND_DATA = 'data:audio/wav;base64,UklGRiYAAABXQVZFZm10IBAAAAABAAEAQB8AAAB9AAACABAAZGF0YQIAAAAAAA==';

export function useNotificationSound() {
  const [soundEnabled, setSoundEnabled] = useState(() => {
    try {
      return localStorage.getItem('chatSoundEnabled') !== 'false';
    } catch {
      return true;
    }
  });

  const toggleSound = (enabled?: boolean) => {
    const newState = enabled !== undefined ? enabled : !soundEnabled;
    setSoundEnabled(newState);
    try {
      localStorage.setItem('chatSoundEnabled', String(newState));
    } catch {
      // Silently fail if localStorage not available
    }
  };

  const playNotificationSound = useCallback(async (force = false) => {
    if (!soundEnabled && !force) return;

    try {
      const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
      if (audioContext.state === 'suspended') await audioContext.resume();
      const buffer = audioContext.createBuffer(1, audioContext.sampleRate * 0.3, audioContext.sampleRate);
      const data = buffer.getChannelData(0);

      const noteFrequency = 800;
      const sampleRate = audioContext.sampleRate;
      for (let i = 0; i < buffer.length; i++) {
        data[i] = Math.sin(2 * Math.PI * noteFrequency * i / sampleRate) * Math.exp(-i / (sampleRate * 0.3)) * 0.3;
      }

      const source = audioContext.createBufferSource();
      source.buffer = buffer;
      source.connect(audioContext.destination);
      source.start(0);
      source.addEventListener('ended', () => void audioContext.close());
    } catch (error) {
      console.error('Failed to play notification sound:', error);
    }
  }, [soundEnabled]);

  return { soundEnabled, toggleSound, playNotificationSound };
}
